import { render } from "./KontaktSprache.vue?vue&type=template&id=5c53d428"
import script from "./KontaktSprache.vue?vue&type=script&lang=js"
export * from "./KontaktSprache.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__